import {
  CheckOutlined,
  CloseOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Modal,
  Popconfirm,
  Switch,
  Table,
  Tag,
  message,
} from "antd";
import { PlusOutlined, RedoOutlined, UndoOutlined } from "@ant-design/icons";
import { Divider, Radio, Slider } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { ReactSketchCanvas } from "react-sketch-canvas";
/////Redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  OfflineCoreServices,
  CallCoreServicesActionWithToken,
} from "../../appRedux/actions/CoreServicesAction";
import Url from "../../apiCall/UrlConfig";
import moment from "moment-jalaali";
import { TypeList } from "../../component/utility";
import { useNavigate } from "react-router-dom";
//////Redux

const ImagePreAddress = Url.baseURL[0] + Url.downloadImage;

const DentistLabeling = (props) => {
  let navigation = useNavigate();

  const [_showOpgModal, setShowOpgModal] = useState(false);
  const [_showImageDetailModal, setShowImageDetailModal] = useState(false);

  const [_backgroudUrl, setBackgroundUrl] = useState("0");

  const [_opgObj, setOpgObj] = useState(null);

  const [_objImageDetail, setobjImageDetail] = useState({});

  const [selectedRow, setSelectedRow] = useState(null);
  const [selectPatient, setSelectPatient] = useState(null);
  const [selectedOpg, setSelectedOpg] = useState(null);
  const Columns = [
    {
      title: "Patient Id",
      render: (obj, item) => {
        return <div>{item.id}</div>;
      },
    },
    {
      title: "Patient Age",
      render: (obj, item) => {
        return <div>{item.age}</div>;
      },
    },
    {
      title: "maxilla",
      dataIndex: "maxilla",
      key: "maxilla",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "maxilla");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="maxilla"
              style={{ width: "70px" }}
            />
            <div>
              <Button
                style={{ width: "70px" }}
                onClick={() => _onClickDignos(item, "maxilla")}
              >
                تشخیص
              </Button>
            </div>
          </>
        );
      },
    },
    {
      title: "mandible",
      dataIndex: "mandible",
      key: "mandible",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "mandible");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <>
            <img
              key={obj}
              src={imageSource}
              alt="mandible"
              style={{ width: "70px" }}
            />
            <div>
              <Button onClick={() => _onClickDignos(item, "mandible")}>
                تشخیص
              </Button>
            </div>
          </>
        );
      },
    },
    {
      title: "opg",
      dataIndex: "opg",
      key: "opg",
      render: (obj, item, index) => {
        let imageObj = item?.patientImages?.find((o) => o.type == "opg");
        let imageSource = ImagePreAddress + imageObj.imageUrl;
        return (
          <div onClick={() => _onClickOpg(imageObj)}>
            <img
              key={obj}
              src={imageSource}
              alt="opg"
              style={{ width: "50px" }}
            />
          </div>
        );
      },
    },
    {
      title: "وضیعت (فک)",
      dataIndex: "status",
      key: "status",
      render: (obj, item, index) => {
        let MaxillaObj = item?.patientImages?.find((o) => o.type == "maxilla");
        let MandibleObj = item?.patientImages?.find(
          (o) => o.type == "mandible"
        );

        let IsCheckedMaxilla = MaxillaObj.patientImageDetails.length > 0;
        let IsCheckMandible = MandibleObj.patientImageDetails.length > 0;

        return (
          <div>
            <div className="flex-row-space-around">
              <div>بالا</div>

              <div onClick={() => _onClickDetail(MaxillaObj, IsCheckedMaxilla)}>
                {IsCheckedMaxilla ? (
                  <span>
                    <InfoCircleOutlined />
                  </span>
                ) : null}
                {_returnChecked(IsCheckedMaxilla)}
              </div>
            </div>
            <div className="flex-row-space-around margin-top">
              <div>پایین</div>
              <div onClick={() => _onClickDetail(MandibleObj, IsCheckMandible)}>
                {IsCheckMandible ? (
                  <span>
                    <InfoCircleOutlined />
                  </span>
                ) : null}
                {_returnChecked(IsCheckMandible)}
              </div>
            </div>
          </div>
        );
      },
    },
  ];

  const ColumnsImageDetail = [
    { title: "کد", dataIndex: "id", key: "id" },
    { title: "شماره دندان", dataIndex: "numberTooth", key: "numberTooth" },
    { title: "مدل رسم", dataIndex: "typeDetail", key: "typeDetail" },
    {
      title: "تاریخ رسم",
      dataIndex: "registerTime",
      key: "registerTime",

      render: (obj, item, index) => {
        return (
          <>
            <div>{moment(obj).format("jYYYY-jMM-jDD")}</div>
            <div>{moment(obj).format("HH:mm")}</div>
          </>
        );
      },
    },
    {
      title: "عملیات",
      dataIndex: "Action",
      key: "Action",

      render: (obj, item, index) => {
        return (
          <div>
            <Popconfirm
              title="Are you sure to delete this task?"
              onConfirm={(event) => {
                event.stopPropagation();
                _onClickDeleteDetail(item);
              }}
              onCancel={() => {}}
              okText="Yes"
              cancelText="No"
            >
              <Button
                onClick={(event) => {
                  // Prevent the click event from propagating to the row
                  event.stopPropagation();

                  // Your button click logic
                }}
              >
                Delete
              </Button>
            </Popconfirm>
          </div>
        );
      },
    },
  ];

  const [NumberTooth, setNumberTooth] = useState(null);
  const [TypeDetail, setTypeDetail] = useState(null);
  const [listTeethMultiSelect, setListTeethMultiSelect] = useState([
    { label: "8L", value: "8L", checked: false },
    { label: "7L", value: "7L", checked: false },
    { label: "6L", value: "6L", checked: false },
    { label: "5L", value: "5L", checked: false },
    { label: "4L", value: "4L", checked: false },
    { label: "3L", value: "3L", checked: false },
    { label: "2L", value: "2L", checked: false },
    { label: "1L", value: "1L", checked: false },

    { label: "1R", value: "1R", checked: false },
    { label: "2R", value: "2R", checked: false },
    { label: "3R", value: "3R", checked: false },
    { label: "4R", value: "4R", checked: false },
    { label: "5R", value: "5R", checked: false },
    { label: "6R", value: "6R", checked: false },
    { label: "7R", value: "7R", checked: false },
    { label: "8R", value: "8R", checked: false },

    { label: "EL", value: "EL", checked: false },
    { label: "DL", value: "DL", checked: false },
    { label: "CL", value: "CL", checked: false },
    { label: "BL", value: "BL", checked: false },
    { label: "AL", value: "AL", checked: false },

    { label: "AR", value: "AR", checked: false },
    { label: "BR", value: "BR", checked: false },
    { label: "CR", value: "CR", checked: false },
    { label: "DR", value: "DR", checked: false },
    { label: "ER", value: "ER", checked: false },
  ]);

  const _onClickOpg = (imageObj) => {
    setOpgObj(imageObj);
    setShowOpgModal(true);
  };

  const canvasRef = useRef(null);
  const DivRef = useRef(null);

  const [WidthDiv, setWidthDiv] = useState(0);
  const [StrokeWidth, setStrokeWidth] = useState(10);
  let HbeW = 590 / 943;

  if (selectedRow != null && selectedRow.imageWidth > 0) {
    HbeW = selectedRow.imageHeight / selectedRow.imageWidth;
  }
  useEffect(() => {
    if (DivRef.current != null) {
      DivRef.current.scrollIntoView({ behavior: "smooth" });
      console.log("width", DivRef.current.offsetWidth);
      let _width = DivRef.current.offsetWidth;
      if (_width > 500) {
        _width = 500;
      }
      setWidthDiv(_width);
      setBackgroundUrl(ImagePreAddress + selectedRow.imageUrl);
    }
  }, [selectedRow]);

  useEffect(() => {
    _getPatientList();
  }, []);

  useEffect(async () => {
    if (_backgroudUrl == "export") {
      let img = await canvasRef.current.exportImage("png");
      let PathCanvas = await canvasRef.current.exportPaths();
      setBackgroundUrl(ImagePreAddress + selectedRow.imageUrl);

      let _toServer = {
        NumberTooth: NumberTooth ? NumberTooth : "",
        TypeDetail,
        base64Masked: img,
        PathCanvas: JSON.stringify(PathCanvas),
        PatientImageId: selectedRow.id,
        widthImage: WidthDiv,
        heightImage: Math.floor(HbeW * WidthDiv),
      };

      let url = Url.savePatintImageDetail;

      let res = await props.actions.CallCoreServicesActionWithToken(
        url,
        _toServer
      );

      if (res.hasError) {
        message.error(res.message);
        return;
      }

      message.success("با موفقیت ثبت شد");

      canvasRef.current.resetCanvas();
      _getPatientList();
    }
  }, [_backgroudUrl]);

  const _onClickDignos = (item, type) => {
    let imageObj = item?.patientImages?.find((o) => o.type == type);
    let imageSource = ImagePreAddress + imageObj.imageUrl;

    let ImageOpg = item?.patientImages?.find((o) => o.type == "opg");
    let imageSourceOpg = ImagePreAddress + ImageOpg.imageUrl;
    console.log(item);
    setSelectPatient(item);
    setSelectedRow(imageObj);
    setSelectedOpg(imageSourceOpg);
  };
  const _getPatientList = async () => {
    let url = Url.getListPatient;

    let res = await props.actions.CallCoreServicesActionWithToken(url, {});

    console.log(res);

    if (res.hasError) {
      message.warn(res.message);
    }
  };

  const _onPressAdd = async () => {
    if (
      NumberTooth == null &&
      !(TypeDetail == "ortho" || TypeDetail == "healthy")
    ) {
      message.warning("شماره دندان را انتخاب کنید ");
      return;
    }

    if (TypeDetail == null) {
      message.warning("نوع تشخیص را انتخاب کنید");
      return;
    }

    let PathCanvas = await canvasRef.current.exportPaths();
    let svg = await canvasRef.current.exportSvg();
    debugger;
    if (PathCanvas.length == 0 && TypeDetail != "healthy") {
      message.warning("هیچ رسمی بر روی تصویر انجام نشده است ");
      return;
    }

    let base64Masked = await canvasRef.current.exportImage("png");

    setBackgroundUrl("export");
  };

  const _onClickDeleteDetail = async (item) => {
    let url = Url.deleteImageDetail;

    let res = await props.actions.CallCoreServicesActionWithToken(url, item);
    if (res.hasError) {
      message.error(res.message);
      return;
    }
    _getPatientList();
    setShowImageDetailModal(false);
    message.success("با موفقیت حذف شد");
  };

  const _returnChecked = (checked) => {
    if (checked) {
      return (
        <Tag color="#87d068">
          <CheckOutlined />
        </Tag>
      );
    } else {
      return (
        <Tag color="#f50">
          <CloseOutlined />
        </Tag>
      );
    }
  };

  const _onClickDetail = (imgObj, status) => {
    if (status == false) {
      return;
    }
    props.actions.OfflineCoreServices(Url.GetImageDetailById, Url.action, null);

    setobjImageDetail(imgObj);
    console.log(imgObj);
    setShowImageDetailModal(true);
  };

  const _onClickRowImageDetail = async (item) => {
    let url = Url.GetImageDetailById;

    let res = await props.actions.CallCoreServicesActionWithToken(url, item);
  };

  const _returnSelectNumberMulti = () => {
    return (
      <div className="margin-top center-text">
        {listTeethMultiSelect.map((o, index) => {
          return (
            <>
              <Tag
                style={{ cursor: "default" }}
                className="margin-horizontal"
                key={o.value}
                color={o.checked ? "#108ee9" : ""}
                onClick={() => {
                  _onClickTeethMultiSelect(o.label);
                }}
              >
                {o.label}
              </Tag>
              {index == 7 && <Divider type="vertical" />}
              {index == 15 && <div></div>}
              {index == 20 && <Divider type="vertical" />}
            </>
          );
        })}
      </div>
    );
  };

  const _onClickTeethMultiSelect = (label) => {
    let newList = [...listTeethMultiSelect];
    let object = newList.find((o) => o.label == label);
    object.checked = !object.checked;
    let index = newList.findIndex((o) => o.label == label);
    newList[index] = object;

    let _outputNumberTeeth = "";
    newList.map((o) => {
      if (o.checked) {
        _outputNumberTeeth += "," + o.value;
      }
    });
    setNumberTooth(_outputNumberTeeth);
    console.log(_outputNumberTeeth);
    setListTeethMultiSelect(newList);
  };

  const _onchangeType = (value) => {
    setNumberTooth(null);
    setTypeDetail(value);

    let _list = [...listTeethMultiSelect];
    _list.forEach((o) => {
      o.checked = false;
    });

    setListTeethMultiSelect(_list);
  };
  return (
    <div style={{ flex: 1 }}>
      <Button type="primary" onClick={() => navigation("/examreport")}>
        مشاهده نتیجه آزمون
      </Button>
      <Button onClick={() => navigation("/Demo/backtoLabel")}>
        مشاهده فیلم آموزشی{" "}
      </Button>
      <Modal
        footer={null}
        onCancel={() => setShowImageDetailModal(false)}
        open={_showImageDetailModal}
      >
        <div>برای مشاهده یک ردیف را انتخاب کنید</div>
        <Table
          columns={ColumnsImageDetail}
          dataSource={_objImageDetail?.patientImageDetails}
          rowKey={(o) => o.id}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                _onClickRowImageDetail(record);
              }, // click row
            };
          }}
        />
        {props.coreData[Url.GetImageDetailById]?.[Url.action]?.data
          ?.base64Masked != null && (
          <>
            {" "}
            <img
              style={{
                width: "50%",
                backgroundImage:
                  "url(" + ImagePreAddress + _objImageDetail.imageUrl + ")",
                backgroundSize: "cover",
              }}
              src={
                props.coreData[Url.GetImageDetailById]?.[Url.action]?.data
                  ?.base64Masked
              }
            />
            <img
              style={{ width: "50%" }}
              src={ImagePreAddress + _objImageDetail.imageUrl}
            />
          </>
        )}
      </Modal>
      <Modal
        footer={null}
        onCancel={() => setShowOpgModal(false)}
        open={_showOpgModal}
      >
        <img
          src={ImagePreAddress + _opgObj?.imageUrl}
          alt="opg"
          style={{ width: "100%" }}
        />
      </Modal>
      <Table
        dataSource={
          props.coreData[Url.getListPatient]?.[Url.action]?.data?.listPatient
        }
        columns={Columns}
        rowKey={(o) => o.id}
      />

      {selectedRow != null && (
        <div>
          <div className="justify-center">
            Pateint Id={selectedRow.patientId}
          </div>
          <div className="justify-center"> Age={selectPatient.age}</div>
          <div className="justify-center">
            <img
              key={selectedOpg}
              src={selectedOpg}
              alt="opg"
              style={{ width: "300px" }}
            />
          </div>
          <div className="" ref={DivRef}>
            {/* <img src={selectedRow.opg} alt="Jaw" style={{ width: "100%" }} /> */}
            <div className="flex-row ">
              <div>اندازه قلم=</div>
              <div style={{ color: "red" }}>{StrokeWidth}</div>
              <Slider
                key={selectedRow}
                className="flex-1"
                min={1}
                max={20}
                onChange={(newStroke) => setStrokeWidth(newStroke)}
                value={StrokeWidth}
                // tooltip={{ open: true }}
              />
            </div>

            <div className="justify-center">
              <ReactSketchCanvas
                id={1}
                key={WidthDiv}
                style={{ width: WidthDiv, height: WidthDiv * HbeW }}
                ref={canvasRef}
                strokeWidth={StrokeWidth}
                strokeColor="black"
                exportWithBackgroundImage={true}
                backgroundImage={_backgroudUrl}
                preserveBackgroundImageAspectRatio={true}
              />
            </div>

            <Button onClick={() => canvasRef.current.undo()}>
              <UndoOutlined />
              undo
            </Button>
            <Button onClick={() => canvasRef.current.redo()}>
              <RedoOutlined />
              redo
            </Button>

            <div className="margin-top center-text">
              <div>تایپ رسم خود را مشخص کنید</div>
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                size="small"
                onChange={(e) => {
                  _onchangeType(e.target.value);
                }}
                value={TypeDetail}
              >
                {TypeList.map((o) => {
                  return <Radio value={o.value}>{o.title}</Radio>;
                })}
              </Radio.Group>
            </div>

            {TypeDetail != null && TypeDetail != "ortho" && (
              <div className="margin-top center-text">
                <div>شماره دندان (برای هر دندان جدا باید ثبت شود)</div>

                <Radio.Group
                  optionType="button"
                  buttonStyle="solid"
                  size="small"
                  value={NumberTooth}
                  onChange={(e) => setNumberTooth(e.target.value)}
                >
                  <Radio value="8L">8</Radio>
                  <Radio value="7L">7</Radio>
                  <Radio value="6L">6</Radio>
                  <Radio value="5L">5</Radio>
                  <Radio value="4L">4</Radio>
                  <Radio value="3L">3</Radio>
                  <Radio value="2L">2</Radio>
                  <Radio value="1L">1</Radio>
                  <Divider type="vertical" />
                  <Radio value="1R">1</Radio>
                  <Radio value="2R">2</Radio>
                  <Radio value="3R">3</Radio>
                  <Radio value="4R">4</Radio>
                  <Radio value="5R">5</Radio>
                  <Radio value="6R">6</Radio>
                  <Radio value="7R">7</Radio>
                  <Radio value="8R">8</Radio>

                  <div
                    className="margin-top"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div>دندان شیری</div>
                    <Radio value="EL">E</Radio>
                    <Radio value="DL">D</Radio>
                    <Radio value="CL">C</Radio>
                    <Radio value="BL">B</Radio>
                    <Radio value="AL">A</Radio>
                    <Divider type="vertical" />
                    <Radio value="AR">A</Radio>
                    <Radio value="BR">B</Radio>
                    <Radio value="CR">C</Radio>
                    <Radio value="DR">D</Radio>
                    <Radio value="ER">E</Radio>
                  </div>
                </Radio.Group>
              </div>
            )}

            {TypeDetail != null &&
              TypeDetail === "ortho" &&
              _returnSelectNumberMulti()}

            <div className="margin-top" style={{ textAlign: "center" }}>
              <Button
                loading={
                  props.coreData[Url.savePatintImageDetail]?.[Url.action]
                    ?.isFetching
                }
                onClick={_onPressAdd}
                type="primary"
              >
                افزودن <PlusOutlined />
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const actionCreators = Object.assign(
  {},
  { CallCoreServicesActionWithToken, OfflineCoreServices }
);
const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
});

const mapStateToProps = (state) => ({
  coreData: state.coreservices.coreData,
});

export default connect(mapStateToProps, mapDispatchToProps)(DentistLabeling);
